import {Container, ContainerProps} from '@mui/material';
import {forwardRef} from 'react';

export type LegacyContainerProps = ContainerProps;

const LegacyContainer = forwardRef<HTMLDivElement, LegacyContainerProps>((props, ref) => (
  <Container ref={ref} {...props} />
));

LegacyContainer.displayName = 'LegacyContainer';

export default LegacyContainer;
